import { formatRelativeTime } from "../../intelligence/intelligenceLabels";
import { scheduleLabel } from "./dataSourceScheduleUtils";

const STATUS_GUIDE = {
  healthy: "The last collection succeeded.",
  warning: "The last collection finished with something to review.",
  failed: "The last collection failed.",
  running: "A collection is in progress.",
  queued: "A collection is waiting to start.",
  never_run: "This source has not collected yet.",
  disabled: "Collection is turned off.",
  stale: "This source has not collected recently.",
  manual_only: "This source is limited to manual runs.",
  manual_ingest_validated: "Manual ingest was validated; not a live freshness guarantee.",
  manual_ingest_validated_with_warnings: "Manual ingest validated with warnings.",
  unknown: "The latest status is not available.",
};

export function statusGuide(health) {
  const key = String(health || "unknown").toLowerCase();
  return STATUS_GUIDE[key] || STATUS_GUIDE.unknown;
}

export function collectionSummary(source) {
  if (!source?.enabled) {
    return "Off";
  }
  if (source.scheduleEnabled) {
    return scheduleLabel(source);
  }
  return "On, only when you start it";
}

export function lastResultSummary(source) {
  const latest = source?.latestRun;
  const hasRun = Boolean(
    source?.lastRunAt || latest?.id || latest?.runId || latest?.status || latest?.startedAt
  );
  if (!hasRun) {
    return "Has not run yet";
  }

  // Prefer the latest run's counts so a newer failed/empty run is not masked by older success totals.
  const found = latest?.recordsReceived ?? latest?.recordsFound ?? source.recordsFound ?? 0;
  const created =
    latest?.recordsInserted ?? latest?.recordsCreated ?? source.recordsCreated ?? 0;
  const updated = latest?.recordsUpdated ?? source.recordsUpdated ?? 0;
  const when = latest?.startedAt || latest?.finishedAt || source.lastRunAt
    ? formatRelativeTime(latest?.startedAt || latest?.finishedAt || source.lastRunAt)
    : null;
  const status = String(latest?.status || source.lastStatus || "").toLowerCase();
  const statusLabel =
    status === "failed" || status === "error"
      ? "Failed"
      : status === "completed_with_errors" || status === "warning"
        ? "Finished with warnings"
        : null;
  const counts = `Found ${found}, added ${created}, updated ${updated}`;
  const withStatus = statusLabel ? `${statusLabel} · ${counts}` : counts;
  return when ? `${withStatus} · ${when}` : withStatus;
}
